module.exports = __webpack_public_path__ + "img/enter-button.f642f7da.png";